import { getAxiosClient } from "../../axios-client";
import { PostAddSubcontractorToWarehouseRequestBody, PostAddSubcontractorToWarehousResponse } from "./types";

const axiosClient = getAxiosClient();
export const addSubcontractorToWarehouse = async (body: PostAddSubcontractorToWarehouseRequestBody) => {
    return await axiosClient.ax.post<PostAddSubcontractorToWarehousResponse>("/Subcontractor/AddSubcontractorToWarehouse", body);
};
